import { Input } from '@/components/ui/input';
import { EngagementAdminConfig } from '@/generated/graphql';
import { configChanged } from '@/providers/AdminEngagementProvider/actions';
import { useAdminEngagementContext } from '@/providers/AdminEngagementProvider/AdminEngagementContext';
import { StringKeys } from '@/types/common';

export function StringConfigInput<TConfig extends EngagementAdminConfig>({
  configKey,
  placeholder,
}: {
  configKey: StringKeys<TConfig>;
  placeholder?: string;
}) {
  const { state, dispatch } = useAdminEngagementContext();
  const value = (state.config as TConfig)?.[configKey] ?? '';

  return (
    <Input
      value={String(value)}
      onChange={(e) => {
        dispatch(configChanged({ config: { [configKey]: e.target.value } }));
      }}
      placeholder={placeholder}
    />
  );
}
